import React from "react";
import { Row, Col, Card, Spinner, Alert, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPeopleGroup } from "@fortawesome/free-solid-svg-icons";
import SalesPersonCard from "components/cards/SalesPersonCard";
import { SalesData } from "../types";

interface TeamPerformanceProps {
  salesData: SalesData[];
  loading: boolean;
  error: string | null;
  onRefresh: () => void;
}

export const TeamPerformance: React.FC<TeamPerformanceProps> = ({
  salesData,
  loading,
  error,
  onRefresh,
}) => {
  return (
    <Row className="mb-4">
      <Col>
        <Card className="border-0 shadow-sm">
          <Card.Header
            className="border-0 py-3"
            style={{
              borderRadius: "16px 16px 0 0",
              borderBottom: "1px solid var(--phoenix-tertiary-bg)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <FontAwesomeIcon
                icon={faPeopleGroup}
                className="text-info"
                style={{ fontSize: "18px" }}
              />
              <div>
                <h6
                  className="mb-1 text-body-emphasis fw-bold"
                  style={{
                    fontSize: "16px",
                    fontFamily: "Inter, -apple-system, sans-serif",
                  }}
                >
                  Desempenho Individual
                </h6>
                <p
                  className="mb-0 text-body-tertiary"
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                  }}
                >
                  Ranking baseado no percentual de meta atingida
                </p>
              </div>
            </div>
          </Card.Header>
          <Card.Body className="p-4">
            {loading ? (
              <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2 text-muted">
                  Carregando ranking...
                </p>
              </div>
            ) : error ? (
              <Alert variant="danger" className="text-center">
                <div>{error}</div>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={onRefresh}
                  className="mt-2"
                >
                  Tentar novamente
                </Button>
              </Alert>
            ) : salesData.length === 0 ? (
              <div className="text-center py-5">
                <FontAwesomeIcon
                  icon={faPeopleGroup}
                  size="3x"
                  className="text-muted mb-3"
                />
                <h5 className="text-muted">
                  Nenhuma meta encontrada
                </h5>
                <p className="text-muted">
                  Configure metas para a equipe para visualizar o
                  ranking de performance.
                </p>
              </div>
            ) : (
              <Row>
                {salesData
                  .sort(
                    (a: SalesData, b: SalesData) =>
                      b.achieved / b.target - a.achieved / a.target
                  )
                  .map((salesPerson: SalesData, index: number) => (
                    <Col
                      lg={4}
                      md={6}
                      className="mb-4"
                      key={salesPerson.id}
                    >
                      <SalesPersonCard
                        salesPerson={{
                          ...salesPerson,
                          rank: index + 1,
                        }}
                      />
                    </Col>
                  ))}
              </Row>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
